export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13819.59ead8e4.jpg";